import { AlertCircle, Plus, RefreshCw } from 'lucide-react'
import React, { useEffect, useState } from 'react'

import AreaGrid from './components/AreaGrid'
import CreateAreaForm from './components/CreateAreaForm'
import PositionList from './components/PositionList'
import { useAreaActions, useAreaState } from './stores/useAreaStore'

const AreaManagement: React.FC = () => {
  const { 
    loading, 
    error, 

    selectedArea 
  } = useAreaState()
  
  const { 
    fetchAreas, 
    selectArea, 
    clearError, 
    refresh 
  } = useAreaActions()

  const [showCreateForm, setShowCreateForm] = useState(false)

  useEffect(() => {
    fetchAreas()
    selectArea(null)
  }, [])

  const handleRefresh = async () => {
    await refresh()
  }

  const handleOpenCreateForm = () => {
    setShowCreateForm(true)
  }

  const handleCloseCreateForm = () => {
    setShowCreateForm(false)
  }

  return (
    <div className="bg-gray-50 ">
      <div className="max-w-7xl mx-auto ">
        {/* 页面标题 */}
        <div className="md:flex md:items-center md:justify-between mb-6">
          <div className="min-w-0 flex-1">
            <h1 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate">
              库位管理
            </h1>
            <p className="mt-1 text-sm text-gray-500">
              管理仓库库区和库位信息
            </p>
          </div>
          <div className="mt-4 flex md:mt-0 md:ml-4 space-x-3">
            <button
              onClick={handleRefresh}
              disabled={loading}
              className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
            >
              <RefreshCw className={`h-4 w-4 mr-2 ${loading ? 'animate-spin' : ''}`} />
              刷新
            </button>
            <button
              onClick={handleOpenCreateForm}
              className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm bg-blue-600 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <Plus className="h-4 w-4 mr-2" />
              新建库区
            </button>
          </div>
        </div>

        {/* 错误提示 */}
        {error && (
          <div className="rounded-md bg-red-50 p-4 mb-6">
            <div className="flex">
              <div className="flex-shrink-0">
                <AlertCircle className="h-5 w-5 text-red-400" />
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-red-800">操作失败</h3>
                <div className="mt-2 text-sm text-red-700">
                  <p>{error}</p>
                </div>
                <div className="mt-4">
                  <div className="-mx-2 -my-1.5 flex">
                    <button
                      type="button"
                      onClick={clearError}
                      className="rounded-md bg-red-50 px-2 py-1.5 text-sm font-medium text-red-800 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-red-50 focus:ring-red-600"
                    >
                      关闭
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* 主要内容区域 */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {/* 左侧：库区列表 */}
          <div className="lg:col-span-1">
            <PositionList />
          </div>

          {/* 右侧：库位网格 */}
          <div className="lg:col-span-3">
            <div className="mb-4">
              <h2 className="text-lg font-medium text-gray-900">
                {selectedArea 
                  ? `${selectedArea.name} - 库位详情` 
                  : '所有库位'
                }
              </h2>
              {selectedArea && selectedArea.description && (
                <p className="mt-1 text-sm text-gray-500">
                  {selectedArea.description}
                </p>
              )}
            </div>
            
            <AreaGrid />
          </div>
        </div>

        {/* 创建库区表单 */}
        <CreateAreaForm
          isOpen={showCreateForm}
          onClose={handleCloseCreateForm}
        />
      </div>
    </div>
  )
}

export default AreaManagement